<template>
    <div class="ds-employee-form-section">
        <div class="flex border-b border-grayxlight mb-4 text-[11px]">
            <div class=" text-darkblue mr-4 cursor-pointer leading-4" v-for="( employment, index) in employments" :key="employment.id"
                :class="{ 'semibold text-[13px] border-b border-x-darkblue': (index === currentTabIndex) }"
                @click="switchTab(+index)">ТУ {{ +index + 1 }}</div>
            <div class="text-[11px] text-gray cursor-pointer" :class="{ 'semibold text-[13px] border-b border-x-darkblue': employmentCreate }" @click="createEmployment">+ Добавить ТУ</div>
        </div>
        <div v-if="employmentCreate">
            <EmploymentsCreate @created="switchTab(0)" @cancel="switchTab(0)" />
        </div>
        <div v-else v-for="(employment, index) in employments" :key="index">
            <EmploymentsTabsItem :employment v-if="index == currentTabIndex" @fired="emit('fired')" :archive />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import EmploymentsTabsItem from './EmploymentsTabsItem.vue';
import EmploymentsCreate from './EmploymentsCreate.vue';
import { useAuthStore } from '@/stores/authStore';
import { useToast } from 'vue-toast-notification';

interface Props {
    employments: any,
    archive: boolean
}

const props = defineProps<Props>()
const emit = defineEmits(['fired'])
const toast = useToast({ position: 'top' })

const authStore = useAuthStore()

const employmentCreate = ref(false)
const currentTabIndex = ref<number>(0)
const employments = computed(() => props.employments.filter((item:any) => (props.archive) ? item.fired_at : !item.fired_at))

const switchTab = (index: number) => {
    currentTabIndex.value = index
    employmentCreate.value = false
}

const createEmployment = () => {
    if(authStore.permissions?.can_create_employment) {
        employmentCreate.value = true
        currentTabIndex.value = 100
    } else {
        toast.error('У вас нет прав на данное действие')
    }  
}
</script>
